import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage';
import Unsubscribe from './components/Unsubscribe';
import WordQuiz from './components/WordQuiz';
import WordPage from './components/WordPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/quiz" element={<WordQuiz />} />
        <Route path="/:slug" element={<WordPage />} />
      </Routes>
    </Router>
  );
}

export default App;